import React from 'react';
import styled from 'styled-components';
import { Button, Input, Table } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { DrawerLayout } from '../../Layout';
import style from './styles';
import { PaginationConfig, paginationStyles } from '../common';

const GameRoomsWrapper = styled.div`
    ${style}
    ${paginationStyles}
`;

interface Props {
    columns: any;
    data: any[];
    search: string;
    setSearch: (value: any) => void;
    onAddClick?: () => void;
    loading?: boolean;
}

const GameRooms: React.FC<Props> = ({ columns, data, search, setSearch, children, onAddClick, loading }) => {
    return (
        <DrawerLayout>
            <GameRoomsWrapper>
                <div className={'header'}>
                    <div className="flex-1" />
                    <div>
                        <Input
                            value={search}
                            allowClear
                            placeholder={'Search room'}
                            prefix={<SearchOutlined />}
                            onChange={(event) => {
                                setSearch(event.target.value);
                            }}
                        />
                    </div>
                    <Button
                        className={'primary-button add-button'}
                        icon={<PlusOutlined />}
                        onClick={() => onAddClick?.()}
                    >
                        Add Room
                    </Button>
                </div>
                <Table
                    loading={loading}
                    rowKey={'id'}
                    columns={columns}
                    dataSource={data}
                    pagination={PaginationConfig}
                />
                {children}
            </GameRoomsWrapper>
        </DrawerLayout>
    );
};

export default GameRooms;
